// MyContext.js
import React, {
  createContext,
  useRef,
  useContext,
  useState,
  useEffect,
} from "react";

const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [functionCalled, setFunctionCalled] = useState(null);
  const [targetId, setTargetId] = useState(null);
  const [isDownloadImage, setIsDownloadImage] = useState(false);
  const [toast, setToast] = useState(null)
  const myRef = useRef(null);
  const callFunction = (id, downloadType, imageFormat) => {
    // // console.log(id, downloadType, imageFormat);
    setTargetId(id);
    setFunctionCalled({ downloadType, imageFormat });
    setTimeout(() => {
      setFunctionCalled(null);
      setTargetId(null);
    }, 1000); // 300ms = 0.3s
  };

  const handleDownloadImage = () => {
    setTimeout(() => {
      setIsDownloadImage(!isDownloadImage);
    }, 1000);
  };
  return (
    <MyContext.Provider
      value={{
        myRef,
        callFunction,
        functionCalled,
        targetId,
        handleDownloadImage,
        isDownloadImage,
        toast,
        setToast
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);
